import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const SurgreadyPatientJourney: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/surgready-patient-journey.excalidraw"
    title="SurgReady $47 Patient Journey"
    subtitle="How patients discover, subscribe, learn, and track their surgical readiness"
  />
);

export default SurgreadyPatientJourney;
